/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component, OnInit} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';

import {ESSService} from './employee-self.service';

import {DATE_MAX} from '../app.constants';
import {Destroyable} from '../destroyable.component';
import {ContractStatus} from '../shared/employees/contract/contract.interfaces';
import {Contract, Employee} from '../shared/employees/employees.model';
import {DateLocalizationPipe} from '../shared/pipes/date-localization.pipe';

@Component({
  selector: 'ess',
  templateUrl: './ess.component.html',
  styleUrls: ['./ess.component.scss']
})
export class ESSComponent extends Destroyable implements OnInit {
  public employee: Employee;
  public selectedContract: Contract;
  public loading: boolean;

  constructor(public essService: ESSService,
              private translate: TranslateService,
              private dateLocalizationPipe: DateLocalizationPipe) {
    super();
    this.customPlaceholderGenerator = this.customPlaceholderGenerator.bind(this);
  }

  public ngOnInit() {
    this.essService.currentContract.subscribe(() => {
      this.employee = this.essService.employee;
      this.selectedContract = this.essService.selectedContract;
    });
  }

  public selectContract(contract: Contract): void {
    this.selectedContract = contract;
    this.essService.selectContract(contract.id);
  }

  public isInactiveContract(contract: Contract): boolean {
    return contract.status === ContractStatus.INACTIVE;
  }

  public customPlaceholderGenerator(contract: Contract, placeholder: string) {
    const text: string = this.translate.instant('EMPLOYEE_FORM.Contract_name', {
      name: contract.cliRegNickName
    });

    const contractDetails = `${text} <span class="nowrap">${this.getContractDate(contract)}</span>`;

    return contract.flag
      ? `<img class="flag-icon" src="${contract.flag.href}" alt="flag" />${contractDetails}`
      : contractDetails;
  }

  public getContractDate(contract: Contract): string {
    return `(${
      this.dateLocalizationPipe.transform(contract.begindate)
    } - ${
      contract.enddate === DATE_MAX || !contract.enddate
        ? '...'
        : this.dateLocalizationPipe.transform(contract.enddate)
    })`;
  }
}
